import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UtilityService } from './../providers/utility.service';
import { AuthenticationService } from './../providers/authentication.service';

@Injectable()
export class FivegPrivateRoutingGuard implements CanActivate {

    id: any;

    constructor(private router: Router) {
      }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(location.href.indexOf('/learn/5g') != -1 || location.href.indexOf('/fiveg/enrollment/selectaccounts') != -1 ) {
            this.router.navigate(['errorPage', 404]);
            return false;
        }
        return true;
    }
}